<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Detalle de gráfico</h4>
    <hr>
    <div class="col-12">

        <div class="textOnInput col-4 col-md-4">
            <label class="form-label">Tipo de gráfico</label>
            <select class="form-select form-input" formControlName="idgraphictype"
                [class.is-invalid]="campoNoValido('idgraphictype')" (change)="onChange($event.target)">
                <option selected disabled value="">Tipo grafico...</option>
                <option *ngFor="let tp of typeGraphics" value="{{tp.id}}">
                    {{tp.name}}
                </option>
            </select>
            <small class="text-danger" *ngIf="campoNoValido('idgraphictype')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Numeración</label>
            <input class="form-control" placeholder="Figura X." formControlName="numeration"
                [class.is-invalid]="campoNoValido('numeration')" type="text">
            <small class="text-danger" *ngIf="campoNoValido('numeration')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Título</label>
            <input class="form-control" placeholder="Título" formControlName="title"
                [class.is-invalid]="campoNoValido('title')" type="text">
            <small class="text-danger" *ngIf="campoNoValido('title')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Nota</label>
            <textarea class="form-control" placeholder="Nota" formControlName="note"
                [class.is-invalid]="campoNoValido('note')" rows="6"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('note')">Este campo es requerido</small>
        </div>

        <ng-container *ngIf="form.value.idgraphictype!=12">
            <!-- inicio Load archivo -->
            <div class="textOnInput col-12 col-md-12">
                <label class="form-label" for="input-file">Elige un archivo</label>

                <div class="label-container ">
                    <div class="row">
                        <div class="col-md-9">
                            <div class="input-group">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                        (click)="fileInput.click()">
                                        Cargar imagen
                                    </button>
                                </div>
                                <input type="text" disabled class="form-control" placeholder="Imagen"
                                    formControlName="urldata">
                            </div>
                            <input #fileInput class="form-file" type="file" id="input-file"
                                (change)="onFileChange($event)" accept="image/png, .jpg, .webp" style="display: none;">
                        </div>

                        <div class="col-md-3">
                            <ng-container *ngIf="form.get('urldata').value != null">
                                <ng-container *ngIf="isUploadDir">
                                    <img class="img-fluid" src="{{URL}}{{form.get('urldata').value}}" alt=""
                                        style="height: 120px; width:100px">
                                </ng-container>
                                <ng-container *ngIf="!isUploadDir">
                                    <img src="{{form.get('urldata').value}}" alt="No se ha cargado una imagen"
                                        style="height: 50px;">
                                </ng-container>
                            </ng-container>
                        </div>

                    </div>
                </div>

            </div>
            <!-- fin Load archivo -->
        </ng-container>
        <ng-container *ngIf="form.value.idgraphictype==12">
            <!-- incio datawrapper -->
            <div class="textOnInput col-12">
                <label class="form-label">Código Datawrapper</label>
                <textarea class="form-control code-form" placeholder="DataWrapper" formControlName="externalframe"
                    rows="6">
                </textarea>
            </div>
            <div class="textOnInput col-12">
                <label class="form-label">Ajustar DataWrapper?</label>
                <div class="label-container align-switch">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="switch2" formControlName="isresponsive">
                    </div>
                </div>
            </div>
            <!-- fin datawrapper -->
        </ng-container>

        <div class="textOnInput col-12">
            <label class="form-label">Orden</label>
            <input class="form-control" type="text" formControlName="order" autocomplete="off"
                [class.is-invalid]="campoNoValido('order')">
            <small class="text-danger" *ngIf="campoNoValido('order')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Estado</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <ng-container *ngIf="!isBlockedTier3">
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </ng-container>
            </div>
        </div>
    </div>

</form>